// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"d614c148","453":"024ca0b2"}[chunkId] + ".chunk.js";
};